(function(args) { 
   
    //paged fix
    jQuery('#form_publications_pagination .pagination .page-numbers').on('click', function(e){
        e.preventDefault();  

        var href = jQuery(this).attr('href');
        jQuery('#form_publications_paged').val(href);

      	var form = jQuery('#form_publications_pagination');
        form[0].action = form[0].action.split('#')[0];
        form[0].action += '#search-publications';
    	form[0].submit();
    });

    //display options sorted_by 
    jQuery('#form_publications .sorted-by').on('click', function(e){
        e.preventDefault();  

        var sorted = jQuery(this).data("sorted");
        jQuery('#form_publications_sorted').val(sorted); 

        var form = jQuery('#form_publications_pagination');
        form[0].action = form[0].action.split('#')[0];
        form[0].action += '#search-publications';
    	form[0].submit();
    });

    //display options display
    jQuery(document).on('click', '#form_publications .display', function(e){
        e.preventDefault();  

        var display = jQuery(this).data("display"); 
        var html ='Display: ';

        if (display == 6) {
        	html += `<span><a href="#" class="display" data-display="3"><span class="icon-table2"></span></a></span> 
                    <span><span class="icon-table"></span></span>`;

        	jQuery('.search-results.search-grid-3').hide();
        	jQuery('.search-results.search-grid-6').show();    
        } else {
        	html += `<span><span class="icon-table2"></span></span>
                     <span><a href="#" class="display" data-display="6"><span class="icon-table"></span></a></span>`;

        	jQuery('.search-results.search-grid-6').hide();
        	jQuery('.search-results.search-grid-3').show();    
        }

        jQuery('.options-display').html(html);
        jQuery('#form_publications_display').val(display);  

    });

})(args); 